// スムーズスクロール
import MoveTo from 'moveto'
const moveto = new MoveTo()
let anchorTags = document.querySelectorAll('a[href^="#"]')
anchorTags = Array.prototype.slice.call(anchorTags, 0)//IE対策
anchorTags.forEach((value) => {
  moveto.registerTrigger(value)
})

// スマフォメニュー
const menu = document.getElementById('menu')
const menuBtn = document.getElementById('menuBtn')

function changeMenu() {
  menu.classList.toggle('is-open');
  menuBtn.classList.toggle('is-open');
}
menuBtn.addEventListener('click', () => {
  changeMenu()
});
let navList = document.querySelectorAll('#menu a');
navList = Array.prototype.slice.call

anchorTags.forEach((list) => {
  list.addEventListener('click', () => {
    changeMenu()
  })
})

window.addEventListener('scroll', (e) => {
  // 遅延ロードの実行を開始するスクロール量を決定。
  [].forEach.call(document.querySelectorAll('img[data-src]'), function (img) {
    if (window.pageYOffset + window.innerHeight * .7 >= img.offsetTop) {
      img.setAttribute('src', img.getAttribute('data-src'));
      img.onload = function () {
        img.removeAttribute('data-src');
      };
    }
  });
});
